import { SelectionPanel } from '$tablet-app/src/app/components/SelectionPanel';
import { toggleInList } from '@akin-home/arrays';
import { MeatType } from '@akin-home/recipes';
import styled from 'styled-components/native';
import { useMealPreferenceDialogState } from '../../store/useMealPreferenceDialogState';

export const MeatTypesView = () => {
  const meat_types = useMealPreferenceDialogState(
    (state) => state.draft_preferences.meats_eaten
  );

  const update = useMealPreferenceDialogState(
    (state) => state.updatePreference
  );

  const onPress = (meat_type: MeatType) =>
    update({ meats_eaten: toggleInList(meat_types, meat_type) });

  return (
    <Container>
      <IconRow>
        <SelectionPanel
          iconColor="#FF4343"
          backgroundColor="rgba(255, 67, 67, 0.15)"
          title="Beef"
          icon="steak"
          value="beef"
          onPress={onPress}
          selected={meat_types?.includes('beef')}
        />
        <SelectionPanel
          iconColor="#059669"
          backgroundColor="rgba(3, 96, 67, 0.15)"
          title="Lamb"
          icon="shish-kebab"
          value="lamb"
          onPress={onPress}
          selected={meat_types?.includes('lamb')}
        />
        <SelectionPanel
          iconColor="#EC93BE"
          backgroundColor="rgba(255, 115, 224, 0.15)"
          title="Pork"
          icon="bacon"
          value="pork"
          onPress={onPress}
          selected={meat_types?.includes('pork')}
        />
      </IconRow>

      <IconRow>
        <SelectionPanel
          iconColor="#1080CC"
          backgroundColor="rgba(83, 90, 241, 0.15)"
          title="Fish"
          icon="fish"
          value="fish"
          onPress={onPress}
          selected={meat_types?.includes('fish')}
        />
        <SelectionPanel
          iconColor="#CF9B07"
          backgroundColor="rgba(255, 191, 9, 0.15)"
          title="Chicken"
          icon="drumstick"
          value="chicken"
          onPress={onPress}
          selected={meat_types?.includes('chicken')}
        />
        <SelectionPanel
          iconColor="#FF7B43"
          backgroundColor="#FFEBE3"
          title="Turkey"
          icon="turkey"
          value="turkey"
          onPress={onPress}
          selected={meat_types?.includes('turkey')}
        />
      </IconRow>
    </Container>
  );
};

const Container = styled.View`
  gap: 30px;
  align-items: center;
  padding: 25px;
`;

const IconRow = styled.View`
  flex-direction: row;
  gap: 30px;
`;
